module.exports = SharedDependencies.ReactDOM['host'];